export default "__VITE_ASSET__DNl7Q7E1__"